import React from 'react';
import ImpcList from './components/ImpcList';


export const FILE_NAME = 'settlement_requests';
export const TITLE = 'SETTLEMENT REQUESTS';

export const TABLE_CARRIER_COLUMN = {
  Header: 'Carrier',
  accessor: 'carrier.label',
  width: 100,
};

export const TABLE_OPERATOR_COLUMN = {
  Header: 'Postal Operator',
  accessor: 'operator.label',
  width: 140,
};
export const TABLE_IMPC_COLUMN = {
  Header: 'Origin IMPC(s)',
  accessor: 'joinedImpcs',
  width: 163,
  filterable: false,
  // eslint-disable-next-line react/prop-types
  Cell: ({ original }) => (
    <>
      { original.joinedImpcs !== '' && <ImpcList data={original.joinedImpcs} /> }
    </>
  ),
};
export const DOWNLOAD_CARRIER_COLUMN = {
  header: 'Carrier',
  key: 'carrier.label',
  width: 12,
};

export const DOWNLOAD_OPERATOR_COLUMN = {
  header: 'Postal Operator',
  key: 'operator.label',
  width: 12,
};

export const TABLE_COLUMNS = [
  {
    Header: 'Settlement Request Name',
    accessor: 'requestName',
    width: 143,
  },
  {
    Header: 'Type',
    accessor: 'requestType',
    width: 186,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ original: { status, requestType = '' } }) => requestType.includes('SCHEDULED') && status,
    width: 185,
  },
  {
    Header: 'Date Type',
    accessor: 'dateType.label',
    width: 205,
  },
  {
    Header: 'Mail Class Type(s)',
    accessor: 'joinedMailClasses',
    width: 163,
  },
  {
    Header: 'Start Date',
    accessor: 'startDate',
    type: 'date',
    width: 120,
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    type: 'date',
    width: 120,
  },
  {
    Header: 'Day report is to be run on',
    accessor: 'runDate',
    type: 'date',
    width: 120,
  },
  {
    Header: 'Specific Search',
    accessor: 'searchField',
    width: 120,
  },
  {
    Header: 'ID',
    accessor: 'searchFieldId',
    width: 265,
  },
  155,
];

export const DOWNLOAD_COLUMNS = [
  {
    header: 'Settlement Request Name',
    key: 'requestName',
    width: 18,
  },
  {
    header: 'Type',
    key: 'requestType',
    width: 22,
  },
  {
    header: 'Date Type',
    key: 'dateType.label',
    width: 14,
  },
  {
    header: 'Origin IMPC(s)',
    key: 'joinedImpcs',
    width: 22,
  },
  {
    header: 'Status',
    key: 'status',
    width: 13,
  },
  {
    header: 'Mail Class Type',
    key: 'joinedMailClasses',
    width: 22,
  },
  {
    header: 'Start Date',
    key: 'startDate',
    width: 15,
  },
  {
    header: 'End Date',
    key: 'endDate',
    width: 15,
  },
  {
    header: 'Specific Search',
    key: 'searchField',
    width: 15,
  },
  {
    header: 'ID',
    key: 'searchFieldId',
    width: 33,
  },
];
